<svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="block"
>
  <rect
    x="3.25"
    y="3.25"
    width="5.5"
    height="5.5"
    rx="1"
    stroke="var(--stroke-color, currentColor)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <rect
    x="11.25"
    y="3.25"
    width="5.5"
    height="5.5"
    rx="1"
    stroke="var(--stroke-color, currentColor)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <rect
    x="11.25"
    y="11.25"
    width="5.5"
    height="5.5"
    rx="1"
    stroke="var(--stroke-color, currentColor)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <rect
    x="3.25"
    y="11.25"
    width="5.5"
    height="5.5"
    rx="1"
    stroke="var(--stroke-color, currentColor)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>